import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { UserState } from "../common/redux/AuthState";

export type EmailSubscriptionDialogProps = {
  user: UserState | null;
  onUpdateSubscription: (
    subscribeToEmails: boolean,
    upn: string,
    token: string
  ) => void;
};

export const EmailSubscriptionDialogAndMenuItem: React.FC<EmailSubscriptionDialogProps> = ({
  user,
  onUpdateSubscription,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleConfirm = () => {
    if (user) {
      onUpdateSubscription(user.subscribeToEmails, user.upn, user.token);
      setIsDialogOpen(false);
    }
  };

  const handleClose = () => setIsDialogOpen(false);

  return (
    <React.Fragment>
      <MenuItem onClick={() => setIsDialogOpen(true)}>
        {user?.subscribeToEmails
          ? "Unsubscribe to emails"
          : "Subscribe to emails"}
      </MenuItem>
      <Dialog maxWidth="md" fullWidth open={isDialogOpen} onClose={handleClose}>
        <DialogTitle>Update email subscriptions</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1">
                <b>
                  {user?.subscribeToEmails
                    ? "Are you sure you want to unsubscribe from receiving emails?"
                    : "Are you sure you want to subscribe to emails?"}
                </b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {user?.subscribeToEmails
                  ? "You will no longer receive email alerts for new notifications."
                  : "You will receive an email everytime you receive a notification."}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            data-test="close-email-subscription"
          >
            Close
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            data-test="confirm-email-subscription"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
